import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { confirmable, createConfirmation } from 'react-confirm';

/**
 * Dialogo de confirmación. Se exporta la funcion confirm, que devuelve una promesa que
 * se resuelve o rechaza según el input del usuario
 */
const ConfirmDialog = ({ show, proceed, confirmation, title, cancelLabel, proceedLabel }) => {
  return (
    <Modal show={show} centered>
      <Modal.Header closeButton>
        <Modal.Title as="h5">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{confirmation}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            proceed(false);
          }}>
          &nbsp;{cancelLabel}&nbsp;
        </Button>
        <Button
          variant="success"
          onClick={() => {
            proceed(true);
          }}>
          &nbsp;{proceedLabel}&nbsp;
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export function confirm(
  confirmation,
  title = 'Confirmar acción',
  proceedLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  options = {},
) {
  return createConfirmation(confirmable(ConfirmDialog))({
    confirmation,
    title,
    proceedLabel,
    cancelLabel,
    ...options,
  });
}
